






















import Vue from 'vue'
import mixins from 'vue-typed-mixins'

import { Diff } from '@/utils'
import SingleOption from './SingleOption.vue'
import Localized from '@/components/Localized'
import ElementMixin from '../ElementMixin'
import { checkCondition } from '@/utils'
import IsTranslation from '../IsTranslation'

export interface Option {
  variable: string
  label: string | IsTranslation
  disabled?: boolean | object
  required?: boolean | object
  skipped?: boolean | object
}

export default mixins(ElementMixin).extend({
  mixins: [ElementMixin],
  components: { SingleOption, Localized },
  computed: {
    selectedOptions(): number {
      return this.options.filter(option => !this.optionIsEmpty(option)).length
    },
    isEmpty(): boolean {
      if (
        this.selectedOptions < this.min ||
        (this.max && this.selectedOptions > this.max) ||
        this.someIsRequiredButEmpty
      ) {
        return true
      } else {
        return false
      }
    },
    someIsRequiredButEmpty(): boolean {
      return this.options.some(
        e => this.optionIsEmpty(e) && !this.optionIsDisabled(e) && this.optionIsRequired(e)
      )
    },
    someIsEmpty(): boolean {
      return this.options.some(e => this.optionIsEmpty(e) && !this.optionIsDisabled(e))
    },
  },
  methods: {
    optionIsFirstToBeCompleted(option: Option): boolean {
      return option.variable === this.firstEmptyRequiredVariable
    },
    optionIsDisabled({ disabled }: Option): boolean {
      return checkCondition(disabled, this.value)
    },
    optionIsRequired({ required }: Option): boolean {
      return checkCondition(required, this.value)
    },
    optionIsSkipped({ skipped }: Option): boolean {
      return checkCondition(skipped, this.value)
    },
    optionIsEmpty({ variable }: Option): boolean {
      return !this.value[variable]
    },
  },
  props: {
    min: {
      default: 0,
      type: Number,
    },
    max: {
      type: Number,
    },
    options: {
      type: Array as () => Option[],
      default() {
        return []
      },
    },
  },
})
